<template>
  <div :id="data && data.id ? data.id : ''">
    <a
      @click="loadRow()"
      data-toggle="modal"
      data-target="#exampleModalCenter"
      href="#"
      class="name-btn"
    >
      <i
        class="ag-icon ag-icon_expand"
        v-if="!options.label || options.label === ''"
      ></i>
      <span v-if="options.label">{{ options.label }}</span>
    </a>
  </div>
</template>

<script>
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
const store = useStore();
export default {
  name: "tableExpandComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  methods: {
    loadRow() {
      if (this.options && this.options.filter) {
        this.data.filter = this.options.filter;
      }
      try {
        if (this.options && this.options.filter) {
          this.data.filterData = this.options.filter();
        }
      } catch (error) {
        console.log(error);
      }

      store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, this.data);

      if (document.getElementById("ag-tab_hashdetails")) {
        if (this.data.action == "Agent Event") {
          document.getElementById("ag-tab_hashdetails").style.display = "none";
          document.getElementById("ag-tab_processtree").style.display = "none";
          document.getElementById("ag-tab_policy").style.display = "none";
        } else {
          document.getElementById("ag-tab_hashdetails").style.display = "block";
          document.getElementById("ag-tab_processtree").style.display = "block";
          document.getElementById("ag-tab_policy").style.display = "block";
        }
      }

      if (document.getElementById("ag-tab_allalerts"))
        document.getElementById("ag-tab_allalerts").click();
      setTimeout(function () {
        if (document.getElementById("ag-tab_alertdetails"))
          document.getElementById("ag-tab_alertdetails").click();
      }, 150);

      if (document.getElementById("ag-tab_overallview"))
        document.getElementById("ag-tab_overallview").click();
    },
  },
};
</script>

<style scoped></style>
